import { BOOKMARK_TASK_MUTATION } from '@/graphql/queries/tasks';
import { graphqlMutation } from './graphqlClient';

export const bookmarkTask = async (variable: { taskId: number, isBookmarked: boolean }) => {
  const result = await graphqlMutation<{ taskId: number, isBookmarked: boolean }, { bookmarkTask: { id: number } }>(
    BOOKMARK_TASK_MUTATION,
    variable,
  );
  return result.bookmarkTask;
};
